import { _Boolean } from '@/API';
import {
  LoginUserQuery,
  LoginUserQueryVariables,
} from '@/appsync/graphql/user';
import { getLoginUserInfo } from '@/appsync/graphql/user';
import { graphqlQuery } from '@/appsync/service/GraphqlUtils';
import { UserInfo, LoginInfo } from '@/types/type';
import { _BooleanEnum2boolean } from '@/utils/CommonUtils';

export const userInfo: UserInfo = {
  isAdmin: false,
  language: 'ja',
  userName: 'No Name',
  affiliationName: 'No Data',
  useFavoritePanel: false,
  canUseCsr: false,
  canUseCws: false,
  canUseCjk: false,
  canUseCtm: false,
};

export const fetchUserInfo = async (
  loginInfo: LoginInfo
): Promise<UserInfo> => {
  const variables = { ...loginInfo };
  const result = await graphqlQuery<LoginUserQuery, LoginUserQueryVariables>(
    getLoginUserInfo,
    variables
  );
  if (result && result.loginUser) {
    const loginUser = result.loginUser;
    return {
      isAdmin: _BooleanEnum2boolean(loginUser.isAdmin),
      language: loginUser.language,
      userName: loginUser.name,
      affiliationName: loginUser.affiliation,
      useFavoritePanel: _BooleanEnum2boolean(loginUser.displaysFavoritePanel),
      canUseCsr: !!loginUser.csrSchema,
      canUseCws: !!loginUser.cwsSchema,
      canUseCjk: !!loginUser.cjkSchema,
      canUseCtm: !!loginUser.ctmSchema,
    };
  } else {
    return userInfo;
  }
};
